import { useQuery } from "@tanstack/react-query";
import { RequestOrderFormSelectedOptions } from "hooks/api/requestOrder";
import useSelectedContractDocEntry from "hooks/useSelectedContractDocEntry";
import {
  getContractOrderRequestQueryOptions,
  mapDimCodeNameToSelectOption,
} from "./getContractOrderRequestQueryOptions";

const useGetContractOrderRequestSalesTerms = ({
  shipTo,
  shipFrom,
  salesTerms,
  mode,
}: RequestOrderFormSelectedOptions) => {
  const selectedContractDocEntry = useSelectedContractDocEntry();
  return useQuery({
    ...getContractOrderRequestQueryOptions(selectedContractDocEntry, {
      modeOfTransportationCode: mode?.value,
      warehouseCode: shipFrom?.value,
      shipToCode: shipTo?.value,
    }),
    enabled: !!selectedContractDocEntry && !salesTerms,
    keepPreviousData: !!salesTerms,
    select: ({ data }) => data?.SalesTerms?.map(mapDimCodeNameToSelectOption),
  });
};

export default useGetContractOrderRequestSalesTerms;
